import type { ComponentSpec } from "../Processing/types";
import { getMockSpec } from "../DataMocks";

/**
 * Fetch the ComponentSpec for a single widget (used when adding a new widget
 * to an already-loaded dashboard, e.g. after the AddWidgetModal flow).
 *
 * Replace the mock return with:
 *   const res = await axios.get(`${API_URL}/dashboard/${dashboardId}/widget/${widgetId}`);
 *   return res.data.config as ComponentSpec;
 *
 * Endpoint: GET /api/dashboard/:dashboardId/widget/:widgetId
 */
export async function fetchWidgetSpec(
  _dashboardId: string,
  _widgetId: string,
): Promise<ComponentSpec> {
  // TODO: replace with real API call
  void _dashboardId;
  void _widgetId;
  return getMockSpec("chart");
}
